import * as React from 'react'
import PhotoswipeLink from '../../../shared/photoswipe/photoswipe_link'

type PhotoProps = {
  element: {
    id?: number
    template?: {
      photo_thumb?: string
      photo_original?: string
    }
  }
}

export default function Photo (props: PhotoProps) {
  const { element } = props
  const template = element?.template
  const thumbUrl = template?.photo_thumb
  const originalUrl = template?.photo_original
  const galleryId = `preview${element?.id}`

  return (
    <PhotoswipeLink src={originalUrl} galleryId={galleryId}>
      <img src={thumbUrl} alt={thumbUrl} />
    </PhotoswipeLink>
  )
}
